import { useMemo } from 'react'
import { useQuery } from 'apollo-client'
import logger from 'logger'
import { UserError } from 'helpers'

import type { InquireVariables } from './graph/inquire.graphql'
import inquireQuery from './graph/inquire.graphql'

import modifyInquire from './modifyInquire'


type UseInquireQueryProps = {
  variables: InquireVariables
  skip?: boolean
}

const useInquireQuery = (props: UseInquireQueryProps) => {
  const { variables, skip } = props

  const requestedPurchaseLevel = variables?.input?.purchaseLevel || 'ALL'

  const { data, refetch, isFetching } = useQuery(inquireQuery, {
    variables,
    skip,
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  })

  const orderData = useMemo(() => {
    if (!data?.purchaseInquiry) {
      return null
    }

    const { data: inquireData, error } = data.purchaseInquiry

    if (error) {
      logger.warn(new UserError(error))
      return null
    }

    return modifyInquire(inquireData, requestedPurchaseLevel)
  }, [ data, requestedPurchaseLevel ])

  return {
    orderData,
    refetch,
    isFetching,
  }
}


export default useInquireQuery
